import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import {
    getUsers
} from "../../store/action/user";
import AdminUserTable from "../../components/tables/AdminUserTable";
import {Button} from "../../components/buttons";
import axios from "axios";
import {API} from "../../config";
import {CSVLink} from "react-csv";

const AdminDatabase = () => {
    const { token } = isAuthenticated();
    const [ download, setDownload ] = useState(false);
    const [ downloadLoading, setDownloadLoading ] = useState(false);
    const [ file, setFile] = useState([]);
    const [ values , setValues ] = useState({
        start:'',
        end:'',
        type:'order'
    });

    const downloadPayment = async () => {
        setDownloadLoading(true)
        try {
            const res = await axios.post(`${API}/v1/admin/data`, {
                start: values.start,
                end: values.end,
                type: values.type
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`
                }
            });
            if(res.data.success) {
                const files = res.data;
                setDownload(true);
                setFile(files.data)
            } else {
                alert(res.data.error);
            }
        } catch (e) {
            console.log (e);
            setDownloadLoading(false)
            return alert(e.message)
        }
        setDownloadLoading(false)
    };

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const downloadView = () => {
        if (download) {
            return (
                <div className="px-4">
                    <h6>Download File </h6>
                    <div className="row">
                        <div className="col-3">
                            <CSVLink
                                className="btn btn-sm btn-outline-primary btn-block"
                                separator={"|"}
                                filename={`[${values.type}] data ${values.start}-${values.end}.csv`}
                                data={file}>
                                <span className="btn-inner--text ml-2">download {values.type}</span>
                            </CSVLink>
                        </div>
                    </div>
                </div>
            )
        }
        return null
    };

    return (
        <div className="bg-white rounded shadow">
            <div className="px-4 pt-2 pb-4 mb-2">
                <div className="col-6">
                    <h5>Tarik Data </h5>
                </div>
                <div className="row">
                    <div className="col-3">
                        <input
                            type="text"
                            onChange={handleChange('start')}
                            placeholder="Start Date (YYYY-MM-DD)"
                            className="form-control"
                            values={values.start}
                        />
                    </div>

                    <div className="col-3">
                        <input
                            type="text"
                            onChange={handleChange('end')}
                            placeholder="End Date (YYYY-MM-DD)"
                            className="form-control"
                            values={values.end}
                        />
                    </div>

                    <div className="col-3">
                        <select
                            id="inputState"
                            className="form-control"
                            onChange={handleChange('type')}
                        >
                            <option
                                value='order'
                                selected={`${values.type === 'order' ? "selected":""}`}
                            >
                                Order
                            </option>
                            <option
                                value='journey'
                                selected={`${values.type === 'journey' ? "selected":""}`}
                            >
                                Journey
                            </option>
                            <option
                                value='pricing_request'
                                selected={`${values.type === 'pricing_request' ? "selected":""}`}
                            >
                                Pricing Request
                            </option>
                            <option
                                value='assignment'
                                selected={`${values.type === 'assignment' ? "selected":""}`}
                            >
                                Assignment
                            </option>
                        </select>
                    </div>

                    <div className="col-3">
                        <Button
                            onClick={downloadPayment}
                            loading={downloadLoading}
                            className="btn btn-primary btn-block"
                        >
                            {downloadLoading ? "Submitting..." : "Submit"}
                        </Button>
                    </div>
                </div>
            </div>
            <hr/>
            { downloadView() }
            <br/>
            <br/>
        </div>
    )
};


export default AdminDatabase;
